import React, { Component } from 'react';
import './LogIn.css';
import {PostData} from '../services/PostData'

class LogIn extends Component {

  constructor(props){
    super(props);
    this.state ={
      username:'',
      password:''
    }
    this.goTo = undefined;
  }


  redirect = (redirect) =>{
    let url = redirect;
    let props = this.props;
    return function(){
      if(url === false){
       props.history.push("/navigation")
      }
      else{
       window.location.href = url;
      }
      
    } 
  }

  componentDidMount(){
    let submitForm = this.login;
    window.addEventListener('keypress',function(e){
      if (e.keyCode == 13) {
        submitForm()
    }
    })
  }

  getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  };


  componentWillMount(){
    
    var url = new URL(window.location.href);
    var c = url.searchParams.get("redirect") ? url.searchParams.get("redirect") : false;
    this.goTo = this.redirect(c);

    var get_cookie = this.getCookie("pk_token");
    try {
      var jwt_cookie = JSON.parse(decodeURIComponent(get_cookie)).jwt;
      if(sessionStorage.getItem("pk_token") && jwt_cookie){
        this.goTo();
       }
      }
      catch(e){
        console.log("Cookie is invalid")
        sessionStorage.removeItem('pk_token');
        document.cookie = 'pk_token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }

    
  }

login = () =>{

  if(this.state.username && this.state.password){

    PostData('login', this.state).then(result => {
      if(result.jwt){

        var goTo = this.goTo;
        var request = new XMLHttpRequest();
        request.open('POST', '/cookie/');
        request.setRequestHeader('Content-Type', 'text/plain');
        request.onreadystatechange = function() {
          if ((request.readyState===4) && (request.status===200)) { //Check for response:
            if(request.responseText == 1){
            sessionStorage.setItem("pk_token",result.jwt);
            goTo();
            }
            else{
              alert("There was an error logging in. Please try again/")
            }
          }
        }
        request.send(JSON.stringify(result));
        

      }
    }).catch(e =>{
      window.alert("Login Failed")
    })
  }
  else{
    window.alert("Please provide username and password")
  }

}

change =(e) => {
this.setState({[e.target.name]: e.target.value})
}

  render() {
 
    return (   
        <div className="Welcome">
          <form>
          <p className="App-intro">
          <input type="text" name="username" placeholder="username" onChange={this.change} autocomplete="on"/>
          <input type="password" name="password" placeholder="password" onChange={this.change} autocomplete="on"/>
          <input type="button" value="login" name="" id="submit" onClick={this.login} autocomplete="off"/>
          </p>
          </form>
        </div>

    );
  
  }
}

export default LogIn;



// WEBPACK FOOTER //
// ./src/components/LogIn.js